<template>
    <span>
        <v-card-title  primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">{{title}}</v-card-title>
        <v-card-actions  ref="chartContainer"  fill-height style="height:200px;width:100%;padding-top:0px;padding-bottom:0px;">
            <highcharts v-if="load" style="height:200px;width:100%;" :options="optionsFinalized"></highcharts>
        </v-card-actions>
    </span>
</template>

<script>

    import {Chart} from 'highcharts-vue'
    import More from 'highcharts/highcharts-more'
    import Highcharts from 'highcharts'
    import Exporting from 'highcharts/modules/exporting'

    Exporting(Highcharts);

    More(Highcharts);

    export default {
        name: "Chart",
        components: {
             highcharts: Chart
        },
        props: {
            active:Boolean,
            title:String,
            flat:Boolean,
            chartOptions:Object||{}
        },
        computed: {
            optionsFinalized : function () {
                var tmp = this.chartOptions;

                tmp.credits = false;

                return tmp;
            }
        },
        data: function () {
            return {
                load:false,
            }
        },
        methods: {
            onResize() {
                setTimeout(() => {
                    if (typeof this.chartOptions != 'undefined' && !! this.chartOptions.chart && typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            }
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        mounted() {
            setTimeout(() => {
                if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
                    this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                    this.load = true;
                }
            });
        },
        watch: {
            active : function() {
                setTimeout(() => {
                    if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            },
            chartOptions:function() {
                setTimeout(() => {
                    if (typeof this.chartOptions != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
                        this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load = true;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
